module.exports = __webpack_public_path__ + "0800e5867e22dad8346f29b87bc4a955.png";